module.exports = __webpack_public_path__ + "img/silent-knight.6ed38a6d.png";